import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import './Footer.css';

class Footer extends Component {
  render() {
    return <div id="footer"><Link to="/faq">FAQ</Link> | <Link to="/contacts">Contacts</Link></div>
  }
}
export default Footer;
